export default __webpack_public_path__ + "static/media/toledo_3.0f70795c.png";